// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReportFilterDto
 */
export interface IReportFilterDto {
    /**
     * 
     * @type {number}
     * @memberof IReportFilterDto
     */
    employer_id?: number;
    /**
     * 
     * @type {Set<number>}
     * @memberof IReportFilterDto
     */
    employer_ids?: Set<number>;
    /**
     * 
     * @type {boolean}
     * @memberof IReportFilterDto
     */
    show_ssn?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IReportFilterDto
     */
    search_value?: string;
    /**
     * 
     * @type {string}
     * @memberof IReportFilterDto
     */
    card_status_report_group_type?: IReportFilterDtoCardStatusReportGroupTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IReportFilterDto
     */
    is_not_mailed?: boolean;
    /**
     * 
     * @type {Set<string>}
     * @memberof IReportFilterDto
     */
    card_statuses?: Set<IReportFilterDtoCardStatusesEnum>;
    /**
     * 
     * @type {Set<string>}
     * @memberof IReportFilterDto
     */
    employment_statuses?: Set<IReportFilterDtoEmploymentStatusesEnum>;
    /**
     * 
     * @type {Set<string>}
     * @memberof IReportFilterDto
     */
    account_statuses?: Set<IReportFilterDtoAccountStatusesEnum>;
    /**
     * 
     * @type {Set<string>}
     * @memberof IReportFilterDto
     */
    enrollment_statuses?: Set<IReportFilterDtoEnrollmentStatusesEnum>;
    /**
     * 
     * @type {Set<string>}
     * @memberof IReportFilterDto
     */
    cip_statuses?: Set<IReportFilterDtoCipStatusesEnum>;
    /**
     * 
     * @type {Set<string>}
     * @memberof IReportFilterDto
     */
    claim_statuses?: Set<IReportFilterDtoClaimStatusesEnum>;
    /**
     * 
     * @type {Set<string>}
     * @memberof IReportFilterDto
     */
    claim_types?: Set<IReportFilterDtoClaimTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof IReportFilterDto
     */
    claim_activity_date_range_type?: IReportFilterDtoClaimActivityDateRangeTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IReportFilterDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IReportFilterDto
     */
    forfeiture_report_group_type?: IReportFilterDtoForfeitureReportGroupTypeEnum;
    /**
     * 
     * @type {Set<string>}
     * @memberof IReportFilterDto
     */
    plan_year_period?: Set<IReportFilterDtoPlanYearPeriodEnum>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IReportFilterDto
     */
    plan_ids?: Set<number>;
    /**
     * 
     * @type {boolean}
     * @memberof IReportFilterDto
     */
    show_individual_contributions?: boolean;
    /**
     * 
     * @type {Set<string>}
     * @memberof IReportFilterDto
     */
    account_types?: Set<IReportFilterDtoAccountTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof IReportFilterDto
     */
    delinquent_claims_view_type?: IReportFilterDtoDelinquentClaimsViewTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IReportFilterDto
     */
    org_paths_regex?: string;
}

/**
* @export
* @enum {string}
*/
export enum IReportFilterDtoCardStatusReportGroupTypeEnum {
    LAST_7_DAYS = 'LAST_7_DAYS',
    LAST_30_DAYS = 'LAST_30_DAYS'
}
/**
* @export
* @enum {string}
*/
export enum IReportFilterDtoCardStatusesEnum {
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    LOST = 'LOST',
    PENDING_OPEN = 'PENDING_OPEN',
    PENDING_FROZEN = 'PENDING_FROZEN',
    PENDING_REPLACE = 'PENDING_REPLACE',
    STOLEN = 'STOLEN',
    NOT_SENT = 'NOT_SENT',
    PENDING_UNLOCK = 'PENDING_UNLOCK',
    DAMAGED = 'DAMAGED',
    CLOSING = 'CLOSING',
    DEMOGRAPHIC_CHANGE = 'DEMOGRAPHIC_CHANGE'
}
/**
* @export
* @enum {string}
*/
export enum IReportFilterDtoEmploymentStatusesEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
* @export
* @enum {string}
*/
export enum IReportFilterDtoAccountStatusesEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    PENDING = 'PENDING'
}
/**
* @export
* @enum {string}
*/
export enum IReportFilterDtoEnrollmentStatusesEnum {
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    FUTURE = 'FUTURE',
    EXPIRED = 'EXPIRED'
}
/**
* @export
* @enum {string}
*/
export enum IReportFilterDtoCipStatusesEnum {
    NONE = 'NONE',
    PENDING = 'PENDING',
    PASS = 'PASS',
    FAIL = 'FAIL',
    QUESTION = 'QUESTION',
    RENEWED = 'RENEWED',
    CIP_FAILED_ACCOUNT_CLOSE = 'CIP_FAILED_ACCOUNT_CLOSE'
}
/**
* @export
* @enum {string}
*/
export enum IReportFilterDtoClaimStatusesEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
* @export
* @enum {string}
*/
export enum IReportFilterDtoClaimTypesEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}
/**
* @export
* @enum {string}
*/
export enum IReportFilterDtoClaimActivityDateRangeTypeEnum {
    CLAIM_SUBMIT_DATE = 'CLAIM_SUBMIT_DATE',
    CLAIM_PAID_DATE = 'CLAIM_PAID_DATE'
}
/**
* @export
* @enum {string}
*/
export enum IReportFilterDtoForfeitureReportGroupTypeEnum {
    EMPLOYEE = 'EMPLOYEE',
    TRANSACTION = 'TRANSACTION'
}
/**
* @export
* @enum {string}
*/
export enum IReportFilterDtoPlanYearPeriodEnum {
    CURRENT = 'CURRENT',
    PRIOR = 'PRIOR',
    FUTURE = 'FUTURE',
    OLDER = 'OLDER'
}
/**
* @export
* @enum {string}
*/
export enum IReportFilterDtoAccountTypesEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
* @export
* @enum {string}
*/
export enum IReportFilterDtoDelinquentClaimsViewTypeEnum {
    BY_EMPLOYEE = 'BY_EMPLOYEE',
    BY_CLAIM = 'BY_CLAIM'
}


/**
 * Check if a given object implements the IReportFilterDto interface.
 */
export function instanceOfIReportFilterDto(value: object): value is IReportFilterDto {
    return true;
}

export function IReportFilterDtoFromJSON(json: any): IReportFilterDto {
    return IReportFilterDtoFromJSONTyped(json, false);
}

export function IReportFilterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportFilterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_id': json['employer_id'] == null ? undefined : json['employer_id'],
        'employer_ids': json['employer_ids'] == null ? undefined : new Set(json['employer_ids']),
        'show_ssn': json['show_ssn'] == null ? undefined : json['show_ssn'],
        'search_value': json['search_value'] == null ? undefined : json['search_value'],
        'card_status_report_group_type': json['card_status_report_group_type'] == null ? undefined : json['card_status_report_group_type'],
        'is_not_mailed': json['is_not_mailed'] == null ? undefined : json['is_not_mailed'],
        'card_statuses': json['card_statuses'] == null ? undefined : new Set(json['card_statuses']),
        'employment_statuses': json['employment_statuses'] == null ? undefined : new Set(json['employment_statuses']),
        'account_statuses': json['account_statuses'] == null ? undefined : new Set(json['account_statuses']),
        'enrollment_statuses': json['enrollment_statuses'] == null ? undefined : new Set(json['enrollment_statuses']),
        'cip_statuses': json['cip_statuses'] == null ? undefined : new Set(json['cip_statuses']),
        'claim_statuses': json['claim_statuses'] == null ? undefined : new Set(json['claim_statuses']),
        'claim_types': json['claim_types'] == null ? undefined : new Set(json['claim_types']),
        'claim_activity_date_range_type': json['claim_activity_date_range_type'] == null ? undefined : json['claim_activity_date_range_type'],
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'forfeiture_report_group_type': json['forfeiture_report_group_type'] == null ? undefined : json['forfeiture_report_group_type'],
        'plan_year_period': json['plan_year_period'] == null ? undefined : new Set(json['plan_year_period']),
        'plan_ids': json['plan_ids'] == null ? undefined : new Set(json['plan_ids']),
        'show_individual_contributions': json['show_individual_contributions'] == null ? undefined : json['show_individual_contributions'],
        'account_types': json['account_types'] == null ? undefined : new Set(json['account_types']),
        'delinquent_claims_view_type': json['delinquent_claims_view_type'] == null ? undefined : json['delinquent_claims_view_type'],
        'org_paths_regex': json['org_paths_regex'] == null ? undefined : json['org_paths_regex'],
    };
}

export function IReportFilterDtoToJSON(json: any): IReportFilterDto {
    return IReportFilterDtoToJSONTyped(json, false);
}

export function IReportFilterDtoToJSONTyped(value?: IReportFilterDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_id': value['employer_id'],
        'employer_ids': value['employer_ids'] == null ? undefined : Array.from(value['employer_ids'] as Set<any>),
        'show_ssn': value['show_ssn'],
        'search_value': value['search_value'],
        'card_status_report_group_type': value['card_status_report_group_type'],
        'is_not_mailed': value['is_not_mailed'],
        'card_statuses': value['card_statuses'] == null ? undefined : Array.from(value['card_statuses'] as Set<any>),
        'employment_statuses': value['employment_statuses'] == null ? undefined : Array.from(value['employment_statuses'] as Set<any>),
        'account_statuses': value['account_statuses'] == null ? undefined : Array.from(value['account_statuses'] as Set<any>),
        'enrollment_statuses': value['enrollment_statuses'] == null ? undefined : Array.from(value['enrollment_statuses'] as Set<any>),
        'cip_statuses': value['cip_statuses'] == null ? undefined : Array.from(value['cip_statuses'] as Set<any>),
        'claim_statuses': value['claim_statuses'] == null ? undefined : Array.from(value['claim_statuses'] as Set<any>),
        'claim_types': value['claim_types'] == null ? undefined : Array.from(value['claim_types'] as Set<any>),
        'claim_activity_date_range_type': value['claim_activity_date_range_type'],
        'invoice_id': value['invoice_id'],
        'forfeiture_report_group_type': value['forfeiture_report_group_type'],
        'plan_year_period': value['plan_year_period'] == null ? undefined : Array.from(value['plan_year_period'] as Set<any>),
        'plan_ids': value['plan_ids'] == null ? undefined : Array.from(value['plan_ids'] as Set<any>),
        'show_individual_contributions': value['show_individual_contributions'],
        'account_types': value['account_types'] == null ? undefined : Array.from(value['account_types'] as Set<any>),
        'delinquent_claims_view_type': value['delinquent_claims_view_type'],
        'org_paths_regex': value['org_paths_regex'],
    };
}

